<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.CUSTOMER' | translate }}</h1>
                <button
                    *appHasPermissions="[permissions.WriteCustomer]"
                    (click)="openCreateModal()"
                    class="primary"
                    type="button"
                >
                    {{ 'BUTTONS.CREATE_CUSTOMER' | translate }}
                    <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                </button>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'organizationNo'"
            [defaultAscending]="sortKey === 'organizationNo' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'COLUMNS.ORGNO' | translate"
            (sortChanged)="onSortChange('organizationNo', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'name'"
            [defaultAscending]="sortKey === 'name' && sortAscending"
            [sort]="true"
            [dynamicWidth]="50"
            [text]="'COLUMNS.NAME' | translate"
            (sortChanged)="onSortChange('name', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'responsible'"
            [defaultAscending]="sortKey === 'responsible' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'COLUMNS.RESPONSIBLE' | translate"
            (sortChanged)="onSortChange('responsible', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'address'"
            [defaultAscending]="sortKey === 'address' && sortAscending"
            [sort]="true"
            [dynamicWidth]="50"
            [text]="'COLUMNS.ADDRESS' | translate"
            (sortChanged)="onSortChange('address', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'numberOfAgreements'"
            [defaultAscending]="sortKey === 'numberOfAgreements' && sortAscending"
            [sort]="true"
            [width]="14"
            [text]="'FEATURES.CUSTOMER.NUM_OF_AGREEMENTS' | translate"
            (sortChanged)="onSortChange('numberOfAgreements', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'created'"
            [defaultAscending]="sortKey === 'created' && sortAscending"
            [sort]="true"
            [align]="align.Right"
            [width]="12"
            [text]="'COLUMNS.CREATED' | translate"
            (sortChanged)="onSortChange('created', $event)"
        />
        <app-table-header [align]="align.Center" [width]="8" *appHasPermissions="[permissions.WriteCustomer]" />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of customers$ | async" (click)="openCreateModal(item)">
            <td>{{ item.organizationNo }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.responsible }}</td>
            <td>{{ item.address }} {{ item.zipCode }} {{ item.city }}</td>
            <td>{{ item.numberOfAgreements }}</td>
            <td class="right">{{ item.created | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}</td>
            <td class="center" *appHasPermissions="[permissions.WriteCustomer]">
                <button
                    *ngIf="item.isDeletable"
                    (click)="confirmDeleteCustomer($event, item)"
                    class="icon"
                    [ngClass]="{ loading: loadingCustomerIds.includes(item.id) }"
                >
                    <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                </button>
            </td>
        </tr>
    </ng-container>
</app-table>
